import type { ReactNode } from 'react'
import HeaderStat, { formatStatDate } from '../TopDown/components/HeaderStat'
import { formatVND } from '../TopDown/components/formatters'

// Shared AppLayout header for the planning pages: plan name + Scope / Target /
// Period stats, with a right-side actions slot.
export default function PlanHeader({
  name,
  orgNodeName,
  revenueTarget,
  currency,
  beginDate,
  endDate,
  actions,
  planPeriod,
  actualsMonths,
  fullYearTarget,
}: {
  name: string
  orgNodeName: string | null
  revenueTarget: number
  currency: string | null
  beginDate: string
  endDate: string
  actions?: ReactNode
  // A revision plans only the remaining months: the target below covers
  // planPeriod only, and fullYearTarget adds the actual months back in.
  planPeriod?: { start: string; end: string }
  actualsMonths?: number | null
  fullYearTarget?: number | null
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, width: '100%', paddingRight: 12 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
        <div>
          <h1 style={{ fontSize: 16, fontWeight: 700, color: 'var(--foreground)', margin: 0, letterSpacing: '-0.02em' }}>
            {name}
          </h1>
        </div>
        {orgNodeName && <HeaderStat label="Scope" value={orgNodeName} />}
        <HeaderStat
          label={actualsMonths ? 'Remaining Target' : 'Target'}
          value={formatVND(revenueTarget, currency)}
        />
        {actualsMonths && fullYearTarget != null && (
          <HeaderStat label="Full Target" value={formatVND(fullYearTarget, currency)} />
        )}
        <HeaderStat
          label={actualsMonths ? 'Remaining Period' : 'Period'}
          value={actualsMonths && planPeriod
            ? `${formatStatDate(planPeriod.start)} – ${formatStatDate(planPeriod.end)}`
            : `${formatStatDate(beginDate)} – ${formatStatDate(endDate)}`}
        />
      </div>
      {actions}
    </div>
  )
}
